import { ACOES_AVALIACAO } from './catalogoAcoes'
import type { DadoClinicoAcao, IdAcaoAvaliacao } from './tipos'

const ACHADO_OMISSO: DadoClinicoAcao = {
  valor: 'Sem achado anormal relatado ou não informado',
  estado: 'nao_informado',
}

/**
 * Completa uma ficha com os achados omitidos: todo exame do catálogo existe,
 * e o que a ficha não descreve fica `nao_informado` (ausência de dado não
 * significa normal). A lista de exames vem do catálogo, não de uma cópia.
 */
export function preencherAchados(
  especificos: Partial<Record<IdAcaoAvaliacao, DadoClinicoAcao>>,
): Record<IdAcaoAvaliacao, DadoClinicoAcao> {
  const resultado = {} as Record<IdAcaoAvaliacao, DadoClinicoAcao>
  for (const { id } of ACOES_AVALIACAO) {
    resultado[id] = especificos[id] ?? ACHADO_OMISSO
  }
  return resultado
}
